import React from 'react';
import "./style.scss";

const ContactBanner = () => {

  return (
    <div className={"contact-banner"}>
      <div className={"banner"}>
        <img src={`${process.env.PUBLIC_URL}/store-desktop.jpg`} className={"desk"} alt={"Рекомендуем приобретать технику LG только в официальных магазинах"} />
        <img src={`${process.env.PUBLIC_URL}/store-mob.jpg`} className={"mob"} alt={"Рекомендуем приобретать технику LG только в официальных магазинах"} />
        <h3 className={"title"}>Рекомендуем приобретать технику LG только в&nbsp;официальных магазинах</h3>
      </div>
    </div>
  );

};

ContactBanner.propTypes = {};

export default ContactBanner;
